import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './api/prefetch'; // Fire critical API calls immediately (before React mounts)
import { setupChunkErrorHandler } from './hooks/useBuildVersionCheck';
import { setupClientErrorTelemetry } from './helpers/clientErrorTelemetry';
import App from './App.jsx';
import './index.css';
import './pages/sections'; // Register all content-page sections at app boot

// Setup error handlers before rendering app
setupClientErrorTelemetry()
setupChunkErrorHandler()
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { AuthConfigProvider } from './contexts/AuthConfigContext';
import { GameTypeProvider } from './contexts/GameTypeContext';
import { CharityThemeProvider } from './contexts/CharityThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { LayoutStyleProvider } from './contexts/LayoutStyleContext';
import { ColorThemeProvider } from './contexts/ColorThemeContext';
import { EditModeProvider } from './contexts/EditModeContext';
import { ContentProvider } from './contexts/ContentContext';
import { CountdownStyleProvider } from './contexts/CountdownStyleContext';
import { JackpotStyleProvider } from './contexts/JackpotStyleContext';
import { SiteConfigProvider } from './contexts/SiteConfigContext';
import { DraftProvider } from './contexts/DraftContext';
import ErrorBoundary from './components/ErrorBoundary';
import { GeoLocationProvider } from './contexts/GeoLocationContext';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <GeoLocationProvider>
        <CharityThemeProvider>
          <ColorThemeProvider>
            <LayoutStyleProvider>
              <ThemeProvider>
                <AuthProvider>
                  <AuthConfigProvider>
                    <CountdownStyleProvider>
                     <JackpotStyleProvider>
                      <GameTypeProvider>
                        <LanguageProvider>
                          <SiteConfigProvider>
                              <TranslationProvider>
                                  <DraftProvider>
                                    <ContentProvider>
                                      <EditModeProvider>
                                        <App />
                                      </EditModeProvider>
                                    </ContentProvider>
                                  </DraftProvider>
                              </TranslationProvider>
                          </SiteConfigProvider>
                        </LanguageProvider>
                      </GameTypeProvider>
                     </JackpotStyleProvider>
                    </CountdownStyleProvider>
                  </AuthConfigProvider>
                </AuthProvider>
              </ThemeProvider>
            </LayoutStyleProvider>
          </ColorThemeProvider>
        </CharityThemeProvider>
      </GeoLocationProvider>
    </ErrorBoundary>
  </StrictMode>
);
